import { AuthService } from './../../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { first } from 'rxjs/internal/operators/first';
import * as jquery from 'jquery';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  signUpForm: FormGroup;
  submitted = false;
  returnUrl: string;
  error = false;
  errorMsg: string;
  modalText = 'Loading...';
  showPasswordLengthError = true;
  showPasswordLetterError = true;
  showPasswordNumberError = true;
  labelUp = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private pageTitleService: Title,
    private cookieService: CookieService
  ) {
    // Redirect to dashboard if already logged in
    if (this.authService.currentUserValue != null) {
      this.router.navigate(['/user/dashboard']);
    }
  }

  ngOnInit(): void {
    // check if user is logged in
    if (this.cookieService.get('token')) {
      this.router.navigateByUrl('/user/dashboard');
    }

    this.setPageTitle();
    this.setReturnUrl();
    this.setFormControls();
  }

  setReturnUrl() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/email-confirmation';
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Sign Up');
  }

  setFormControls() {
    this.signUpForm = new FormGroup({
      firstName: new FormControl('', [
        Validators.required
      ]),
      lastName: new FormControl('', [
        Validators.required
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(/^(.*[A-Z].*)(.*\d.*)/)
      ]),
      voucher: new FormControl('', [
        Validators.maxLength(10),
      ]),
    });
  }

  // Convenience getter for easy access to form fields
  get f() { return this.signUpForm.controls; }

  onSubmit() {
    this.submitted = true;

    // Stop here if there's form errors
    if (this.signUpForm.invalid) {
        return;
    }

    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Signing up...';

    this.authService.register(
      this.f.firstName.value,
      this.f.lastName.value,
      this.f.email.value,
      this.f.password.value,
      this.f.voucher.value)
      .pipe(first())
      .subscribe(
        data => {
          if (!data.success) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);

            this.error = true;
            this.errorMsg = data.error.msg;

            // Hides the error message after 5 seconds
            setTimeout(function() {
              this.error = false;
            }.bind(this), 5000);

            // Scroll the sidenav to top
            const container = document.getElementById('sign-up-sidenav');
            container.scrollTop = 0;

            return;
          }

          setTimeout(() => {
            // hide progress modal
            this.hideProgressModal();
          }, 500);

          this.router.navigateByUrl(this.returnUrl, {state: {email: this.f.email.value}});
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        });
  }

  showPassword() {
    const passwordInputType = jquery('#password-input').attr('type');
    if (passwordInputType === 'password') {
      jquery('#password-input').attr('type', 'text');
      jquery('#show-password-icon').removeClass('fa-eye-slash');
      jquery('#show-password-icon').addClass('fa-eye');
    } else {
      jquery('#password-input').attr('type', 'password');
      jquery('#show-password-icon').addClass('fa-eye-slash');
      jquery('#show-password-icon').removeClass('fa-eye');
    }
  }

  checkPasswordValidity(event: any, password: string) {
    // track events for alphanumeric, special characters, numpad keys and backspace keys on the keyboard
    if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90) ||
        (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 8) {
      this.showPasswordLetterError = this.hasCapitalLetters(password);
      this.showPasswordNumberError = this.hasNumber(password);
      this.showPasswordLengthError = this.hasValidLength(password);
    }
  }

  hasValidLength(value: string) {
    const validLength = (value.length >= 8) ? true : false;
    return validLength;
  }

  hasCapitalLetters(value: string) {
    return (/[A-Z]/.test(value));
  }

  hasNumber(value: string) {
    const regex = /\d/g;
    return regex.test(value);
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

  checkVoucherValue() {
    if(this.f.voucher.value) {
      this.labelUp = true;
    } else {
      this.labelUp = false;
    }
  }

  pushlabelUp() {
    this.labelUp = true;
  }

}
